const FormTemplateRenderType = {
	FormTemplateRenderType_RenderNew: {
		Type: "RenderNew",
	},
	FormTemplateRenderType_FillSource: {
		Type: "FillSource",
	},
};

export default FormTemplateRenderType;